import { Delete, ErrorOutline } from "@mui/icons-material";
import {
  Autocomplete,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Controller, UseFormReturn, useWatch } from "react-hook-form";
import styles from "./SuccessPlanWorkflow.module.scss";

interface CompetitorContactsItemProps {
  form: UseFormReturn<any>;
  item: Record<"id", string>;
  index: number;
  onRemoveCallback?: (index: number) => void;
}

const CompetitorContactsItem = ({
  form,
  item,
  index,
  onRemoveCallback,
}: CompetitorContactsItemProps) => {
  const { control, setValue } = form;

  const decMakerSentimentWatch = useWatch({
    control,
    name: `competitorContacts.${index}.decMakerSentiment`,
  });
  /*   const competitorFlagWatch = useWatch({
    control,
    name: `competitorContacts.${index}.competitorFlag`,
  }); */

  const isDecMakerAdvocateOfCompetitor = decMakerSentimentWatch === "Advocate of Competitor";
  //const isAdvocateOfCompetitor = competitorFlagWatch === "1";

  return (
    <div
      key={item.id}
      className={styles["flex-vertical-gap"]}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <div
          className={styles["form-field-wrapper"]}
          style={{ width: "160px", flexShrink: 0 }}
        >
          <Typography className={styles["form-field-label"]}>Name:</Typography>
        </div>
        <Controller
          control={control}
          name={`competitorContacts.${index}.decMakerName`}
          render={({ field }) => (
            <TextField
              {...field}
              variant="outlined"
              size="small"
              sx={{ width: "240px", flexShrink: 0 }}
              autoComplete="off"
            />
          )}
        />
        <IconButton
          aria-label="Delete competitor contact"
          size="small"
          sx={{ ml: 1, flexShrink: 0 }}
          onClick={() => onRemoveCallback?.(index)}
        >
          <Delete color="error" />
        </IconButton>
      </div>

      <div style={{ display: "flex" }}>
        <div
          className={styles["form-field-wrapper"]}
          style={{ width: "160px", flexShrink: 0 }}
        >
          <Typography className={styles["form-field-label"]}>Title:</Typography>
        </div>
        <Controller
          control={control}
          name={`competitorContacts.${index}.decMakerTitle`}
          render={({ field }) => (
            <TextField
              {...field}
              variant="outlined"
              size="small"
              sx={{ width: "240px", flexShrink: 0 }}
              autoComplete="off"
            />
          )}
        />
      </div>
      <div style={{ display: "flex" }}>
        <div
          className={styles["form-field-wrapper"]}
          style={{ width: "160px", flexShrink: 0 }}
        >
          <Typography className={styles["form-field-label"]}>Sentiment:</Typography>
        </div>
        <Controller
          control={control}
          name={`competitorContacts.${index}.decMakerSentiment`}
          render={({ field }) => (
            <Autocomplete
              {...field}
              options={["Webex Champion", "Neutral", "Advocate of Competitor"]}
              value={field.value || null}
              onBlur={field.onBlur}
              onChange={(_, option) => {
                const sentiment = option || "";
                field.onChange(sentiment);
                if (sentiment !== "Advocate of Competitor") {
                  setValue(`competitorContacts.${index}.competitorMtg`, []);
                  setValue(`competitorContacts.${index}.competitorDevices`, []);
                  setValue(`competitorContacts.${index}.competitorCalling`, []);
                }
              }}
              getOptionLabel={(o) => o || ""}
              sx={{ width: "240px", flexShrink: 0 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  variant="outlined"
                  placeholder="Select sentiment"
                />
              )}
            />
          )}
        />
      </div>
      {/* {isDecMakerAdvocateOfCompetitor && (
        <div style={{ display: "flex" }}>
          <div
            className={styles["form-field-wrapper"]}
            style={{ width: "160px" }}
          >
            <Typography className={styles["form-field-label"]}>
              Advocate of a Competitor:
            </Typography>
          </div>
          <Controller
            control={control}
            name={`competitorContacts.${index}.competitorFlag`}
            render={({ field }) => (
              <Autocomplete
                {...field}
                disableClearable
                options={YNOptions}
                value={YNOptions.find((o) => o.value === field.value)}
                onBlur={field.onBlur}
                onChange={(_, option) => field.onChange(option?.value)}
                getOptionLabel={(o: any) => o.label || ""}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    variant="outlined"
                    placeholder="Select One"
                    sx={{ width: "240px" }}
                  />
                )}
              />
            )}
          />
        </div>
      )} */}
      {isDecMakerAdvocateOfCompetitor && (
        <div style={{ display: "flex" }}>
          <div
            className={styles["form-field-wrapper"]}
            style={{ width: "160px", flexShrink: 0 }}
          >
            <Typography className={styles["form-field-label"]}>Meetings:</Typography>
          </div>
          <Controller
            control={control}
            name={`competitorContacts.${index}.competitorMtg`}
            render={({ field }) => {
              const values = field.value || [];
              const hasOther = values.includes("Other");

              const toggle = (option: string) => {
                field.onChange(
                  values.includes(option)
                    ? values.filter((v: any) => v !== option)
                    : [...values, option]
                );
              };

              return (
                <FormControl component="fieldset">
                  <FormGroup
                    sx={{
                      alignItems: "flex-start",
                      "& .MuiFormControlLabel-label": {
                        whiteSpace: "nowrap",
                      },
                    }}
                  >
                    <div style={{ display: "flex" }}>
                      <FormControlLabel
                        label="Microsoft"
                        control={
                          <Checkbox
                            checked={values.includes("Microsoft")}
                            onChange={() => toggle("Microsoft")}
                            size="small"
                            sx={{ p: 0.5 }}
                          />
                        }
                        sx={{ width: "160px", flexShrink: 0 }}
                      />
                      <FormControlLabel
                        label="Google Meet"
                        control={
                          <Checkbox
                            checked={values.includes("Google Meet")}
                            onChange={() => toggle("Google Meet")}
                            size="small"
                            sx={{ p: 0.5 }}
                          />
                        }
                      />
                    </div>

                    <div style={{ display: "flex" }}>
                      <FormControlLabel
                        label="Zoom"
                        control={
                          <Checkbox
                            checked={values.includes("Zoom")}
                            onChange={() => toggle("Zoom")}
                            size="small"
                            sx={{ p: 0.5 }}
                          />
                        }
                        sx={{ width: "160px", flexShrink: 0 }}
                      />
                      <Stack
                        direction="row"
                        alignItems="center"
                      >
                        <FormControlLabel
                          label="Other"
                          control={
                            <Checkbox
                              checked={hasOther}
                              onChange={() => toggle("Other")}
                              size="small"
                              sx={{ p: 0.5 }}
                            />
                          }
                        />
                        {hasOther && (
                          <Controller
                            control={control}
                            name={`competitorContacts.${index}.competitorMtgOtherContent`}
                            render={({ field, fieldState }) => (
                              <TextField
                                {...field}
                                variant="outlined"
                                size="small"
                                autoComplete="off"
                                sx={{ width: "240px" }}
                                error={!!fieldState.error}
                                InputProps={{
                                  endAdornment: !!fieldState.error ? (
                                    <Tooltip title={fieldState.error.message}>
                                      <ErrorOutline
                                        color="error"
                                        fontSize="small"
                                      />
                                    </Tooltip>
                                  ) : null,
                                }}
                              />
                            )}
                            rules={{
                              maxLength: {
                                value: 20,
                                message: "Maximum 20 characters",
                              },
                            }}
                          />
                        )}
                      </Stack>
                    </div>
                  </FormGroup>
                </FormControl>
              );
            }}
          />
        </div>
      )}

      {isDecMakerAdvocateOfCompetitor && (
        <div style={{ display: "flex" }}>
          <div
            className={styles["form-field-wrapper"]}
            style={{ width: "160px", flexShrink: 0 }}
          >
            <Typography className={styles["form-field-label"]}>Devices:</Typography>
          </div>
          <Controller
            control={control}
            name={`competitorContacts.${index}.competitorDevices`}
            render={({ field }) => {
              const values = field.value || [];
              const hasOther = values.includes("Other");

              const toggle = (option: string) => {
                field.onChange(
                  values.includes(option)
                    ? values.filter((v: any) => v !== option)
                    : [...values, option]
                );
              };

              return (
                <FormControl component="fieldset">
                  <FormGroup
                    sx={{
                      alignItems: "flex-start",
                      "& .MuiFormControlLabel-label": {
                        whiteSpace: "nowrap",
                      },
                    }}
                  >
                    <div style={{ display: "flex" }}>
                      <FormControlLabel
                        label="Logitech"
                        control={
                          <Checkbox
                            checked={values.includes("Logitech")}
                            onChange={() => toggle("Logitech")}
                            size="small"
                            sx={{ p: 0.5 }}
                          />
                        }
                        sx={{ width: "160px", flexShrink: 0 }}
                      />
                      <FormControlLabel
                        label="Neat"
                        control={
                          <Checkbox
                            checked={values.includes("Neat")}
                            onChange={() => toggle("Neat")}
                            size="small"
                            sx={{ p: 0.5 }}
                          />
                        }
                      />
                    </div>
                    <div style={{ display: "flex" }}>
                      <FormControlLabel
                        label="Poly"
                        control={
                          <Checkbox
                            checked={values.includes("Poly")}
                            onChange={() => toggle("Poly")}
                            size="small"
                            sx={{ p: 0.5 }}
                          />
                        }
                        sx={{ width: "160px", flexShrink: 0 }}
                      />
                      <Stack
                        direction="row"
                        alignItems="center"
                      >
                        <FormControlLabel
                          label="Other"
                          control={
                            <Checkbox
                              checked={hasOther}
                              onChange={() => toggle("Other")}
                              size="small"
                              sx={{ p: 0.5 }}
                            />
                          }
                        />
                        {hasOther && (
                          <Controller
                            control={control}
                            name={`competitorContacts.${index}.competitorDevicesOtherContent`}
                            render={({ field, fieldState }) => (
                              <TextField
                                {...field}
                                variant="outlined"
                                size="small"
                                autoComplete="off"
                                sx={{ width: "240px" }}
                                error={!!fieldState.error}
                                InputProps={{
                                  endAdornment: !!fieldState.error ? (
                                    <Tooltip title={fieldState.error.message}>
                                      <ErrorOutline
                                        color="error"
                                        fontSize="small"
                                      />
                                    </Tooltip>
                                  ) : null,
                                }}
                              />
                            )}
                            rules={{
                              maxLength: {
                                value: 20,
                                message: "Maximum 20 characters",
                              },
                            }}
                          />
                        )}
                      </Stack>
                    </div>
                  </FormGroup>
                </FormControl>
              );
            }}
          />
        </div>
      )}

      {isDecMakerAdvocateOfCompetitor && (
        <div style={{ display: "flex" }}>
          <div
            className={styles["form-field-wrapper"]}
            style={{ width: "160px", flexShrink: 0 }}
          >
            <Typography className={styles["form-field-label"]}>Calling:</Typography>
          </div>
          <Controller
            control={control}
            name={`competitorContacts.${index}.competitorCalling`}
            render={({ field }) => {
              const values = field.value || [];
              const hasOther = values.includes("Other");

              const toggle = (option: string) => {
                field.onChange(
                  values.includes(option)
                    ? values.filter((v: any) => v !== option)
                    : [...values, option]
                );
              };

              return (
                <FormControl component="fieldset">
                  <FormGroup
                    sx={{
                      alignItems: "flex-start",
                      "& .MuiFormControlLabel-label": {
                        whiteSpace: "nowrap",
                      },
                    }}
                  >
                    <div style={{ display: "flex" }}>
                      <FormControlLabel
                        label="Microsoft"
                        control={
                          <Checkbox
                            checked={values.includes("Microsoft")}
                            onChange={() => toggle("Microsoft")}
                            size="small"
                            sx={{ p: 0.5 }}
                          />
                        }
                        sx={{ width: "160px", flexShrink: 0 }}
                      />
                      <FormControlLabel
                        label="Ring"
                        control={
                          <Checkbox
                            checked={values.includes("Ring")}
                            onChange={() => toggle("Ring")}
                            size="small"
                            sx={{ p: 0.5 }}
                          />
                        }
                      />
                    </div>
                    <div style={{ display: "flex" }}>
                      <FormControlLabel
                        label="Avaya"
                        control={
                          <Checkbox
                            checked={values.includes("Avaya")}
                            onChange={() => toggle("Avaya")}
                            size="small"
                            sx={{ p: 0.5 }}
                          />
                        }
                        sx={{ width: "160px", flexShrink: 0 }}
                      />
                      <FormControlLabel
                        label="Polycomm"
                        control={
                          <Checkbox
                            checked={values.includes("Polycomm")}
                            onChange={() => toggle("Polycomm")}
                            size="small"
                            sx={{ p: 0.5 }}
                          />
                        }
                      />
                    </div>

                    <Stack
                      direction="row"
                      alignItems="center"
                    >
                      <FormControlLabel
                        label="Other"
                        control={
                          <Checkbox
                            checked={hasOther}
                            onChange={() => toggle("Other")}
                            size="small"
                            sx={{ p: 0.5 }}
                          />
                        }
                      />
                      {hasOther && (
                        <Controller
                          control={control}
                          name={`competitorContacts.${index}.competitorCallingOtherContent`}
                          render={({ field, fieldState }) => (
                            <TextField
                              {...field}
                              variant="outlined"
                              size="small"
                              autoComplete="off"
                              sx={{ width: "240px" }}
                              error={!!fieldState.error}
                              InputProps={{
                                endAdornment: !!fieldState.error ? (
                                  <Tooltip title={fieldState.error.message}>
                                    <ErrorOutline
                                      color="error"
                                      fontSize="small"
                                    />
                                  </Tooltip>
                                ) : null,
                              }}
                            />
                          )}
                          rules={{
                            maxLength: {
                              value: 20,
                              message: "Maximum 20 characters",
                            },
                          }}
                        />
                      )}
                    </Stack>
                  </FormGroup>
                </FormControl>
              );
            }}
          />
        </div>
      )}
    </div>
  );
};

export default CompetitorContactsItem;
